import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatDate, formatViews, getCategoryName } from "@/utils/catalog";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - ${getCategoryName(movie.category)}影片资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/0 to-foreground-950/0 opacity-80" />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-1.5 py-0.5 text-[11px] font-medium text-accent-300">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-background-50/90 px-1.5 py-0.5 text-[11px] text-foreground-700">
          {getCategoryName(movie.category)}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 text-[11px] text-background-50/90">
          <i className="ri-eye-line" /> {formatViews(movie.views)}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl" />
          </span>
        </span>
        {rank ? (
          <span className="absolute bottom-0 left-0 flex h-8 w-8 items-center justify-center rounded-tr-lg bg-accent-500 font-heading text-sm font-semibold text-foreground-950">
            {rank}
          </span>
        ) : null}
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate font-heading text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1.5 truncate text-xs text-foreground-500">
          {movie.tags.slice(0, 2).join(" · ")} · {movie.region}
        </p>
        <div className="mt-auto flex items-center justify-between pt-2.5 text-[11px] text-foreground-400">
          <span>{movie.year}</span>
          <span>{formatDate(movie.updatedAt)} 更新</span>
        </div>
      </div>
    </Link>
  );
}